import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import publicRoutes from './routes/PublicRoutes';
import Header from './components/Header';
import { Footer } from './components';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
        <div style={{ marginBottom: '95px' }}>
          <Header />
        </div>
        <Routes>
          {/* Public Routes */}
          {publicRoutes.map((route, index) => (
            <Route path={route.path} element={route.element} key={index} />
          ))}
        </Routes>
        <div>
          <Footer />
        </div>
        <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
